export enum CashoutLocation {
	MY_BETS = "my-bets",
	OFFER = "offer",
}
